import * as React from "react";
import strings from "../../common/utils/StringManager";

interface IPaginationProps {
	itemsPerPage: number,
	maxItems: number,
	currentPage: number,

	callback: (page: number) => void
}

export class Pagination extends React.Component<IPaginationProps> {

	render() {
		var pageCounts = this.props.maxItems / this.props.itemsPerPage;
		var elements = [];
		for (let i = 0; i < pageCounts; i++) {
			if (this.props.currentPage != i) {
				elements.push(<span key={i} className="btn link" onClick={() => this.props.callback(i)}>{i + 1}</span>);
			}
			else {
				elements.push(<span key={i} className="current btn link">{i + 1}</span>);
			}
		}

		var prew = <span className="current prev btn link">{strings.get("gridPrevious")}</span>;
		if (this.props.currentPage > 0) {
			prew = <span className="next btn link" onClick={() => this.props.callback(this.props.currentPage - 1)}>{strings.get("gridPrevious")}</span>
		}

		var next = <span className="current next btn link">{strings.get("gridNext")}</span>;
		if (this.props.currentPage < pageCounts - 1) {
			next = <span className="next btn link" onClick={() => this.props.callback(this.props.currentPage + 1)}>{strings.get("gridNext")}</span>
		}

		return (<div className="pagination">
			{prew}
			{elements}
			{next}
		</div>);
	}
}